import type { Item } from '../app/services/api/orderManagementClient';

type ParQuantityItem = Pick<Item, 'parLevel' | 'minQuantity' | 'maxQuantity'> & {
  stockOnHand: unknown;
};

export const parseNumericStock = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string') {
    const normalizedValue = value.replace(/,/g, '').trim();
    if (normalizedValue.length === 0) {
      return null;
    }

    const parsedValue = Number(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  return null;
};

export const clampParQuantity = (rawQuantity: number, minQuantity?: number | null, maxQuantity?: number | null): number => {
  if (rawQuantity <= 0) {
    return 0;
  }

  let quantity = rawQuantity;

  if (minQuantity != null && minQuantity > 0 && quantity < minQuantity) {
    quantity = minQuantity;
  }

  if (maxQuantity != null && maxQuantity > 0 && quantity > maxQuantity) {
    quantity = maxQuantity;
  }

  return quantity;
};

export const calculateItemParQuantity = (item: ParQuantityItem): number | null => {
  if (item.parLevel == null) {
    return null;
  }

  const stockOnHand = parseNumericStock(item.stockOnHand) ?? 0;
  return clampParQuantity(item.parLevel - stockOnHand, item.minQuantity, item.maxQuantity);
};